import { Checkbox, Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import AtterbergLimitChartSection from 'Components/Worksheets/AtterbergLimitWorksheet/Shared/ChartSection';
import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';

let BsEnIsoResultsSectionMethodB: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const LLResultCannotBeObtained = useSelector(
    pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false))
  );

  return (
    <NamePrefixModifier appendNamePrefix="Results">
      <ListFieldSection>
        <Field input={<TextOutput />} name="LiquidLimitPenetration" />
        <Field input={<TextOutput />} name="LiquidLimitWaterContent" />
        {!LLResultCannotBeObtained ? (
          <Field input={<TextOutput />} name="LiquidLimitCorrelationFactor" />
        ) : (
          <Field input={<TextOutput />} label="Correlation Factor" value="" />
        )}
      </ListFieldSection>
      <ListFieldSection>
        <Field input={<TextOutput />} name="LiquidLimitText" />
        <Field input={<TextOutput />} name="PlasticLimitText" />
        <Field input={<TextOutput />} name="PlasticityIndexText" />
      </ListFieldSection>
      <ListFieldSection heading="Optional Results">
        <Field input={<TextOutput />} name="LiquidityIndexText" />
        <Field input={<TextOutput />} name="ConsistencyIndex" />
        <Field input={<NumericInput />} name="ActivityIndexCorrectionFactor" />
        <Field input={<TextOutput />} name="ActivityIndex" />
      </ListFieldSection>
      <NamePrefixModifier namePrefix="plasticityChart">
        <AtterbergLimitChartSection wide height={500} />
      </NamePrefixModifier>
      <ListFieldSection heading="Report">
        <FieldSet>
          <Field input={<Checkbox />} name="ReportLiquidityIndex" />
          <Field input={<Checkbox />} name="ReportConsistencyIndex" />
          <Field input={<Checkbox />} name="ReportActivityIndex" />
          <Field input={<Checkbox />} name="ReportPlasticityChart" />
        </FieldSet>
      </ListFieldSection>
    </NamePrefixModifier>
  );
};

BsEnIsoResultsSectionMethodB = withInjectedProps(BsEnIsoResultsSectionMethodB);

export { BsEnIsoResultsSectionMethodB };
export default BsEnIsoResultsSectionMethodB;
